import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import apinode from '../../services/apinode'
import { getValue } from '../../utils/getValue'

const PagamentosModal = ({ showModal, setShowModal, pedido }) => {
  const [dados, setDados] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleClose = () => setShowModal(false)

  useEffect(() => {
    // Só faz a requisição se o modal for aberto e o pedido for válido
    if (showModal && pedido) {
      fetchDadosPagamentos()
    }
  }, [showModal, pedido])

  // Função para buscar os dados do backend
  const fetchDadosPagamentos = async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await apinode.get(
        `/pedido/listapgto/${pedido}/${localStorage.idconta}`,
      )
      setDados(response.data) // Atualiza os dados com a resposta do servidor
    } catch (err) {
      console.error('Erro ao buscar dados:', err)
      setError('Erro ao carregar os dados.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>Detalhes do Pedido: {pedido}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p>Carregando...</p>
        ) : error ? (
          <p>{error}</p>
        ) : dados.length > 0 ? (
          <Table
            striped
            bordered
            hover
            size="sm"
          >
            <thead>
              <tr>
                <th>ID Registro</th>
                <th>ID Caixa</th>
                <th>ID Pedido</th>
                <th>Data</th>
                <th>Valor do Pedido</th>
                <th>Forma de Pagamento</th>
                <th>Troco</th>
                <th>Valor Recebido</th>
              </tr>
            </thead>
            <tbody>
              {dados.map((item) => (
                <tr key={item.id_registro}>
                  <td>{item.id_registro}</td>
                  <td>{item.id_cx}</td>
                  <td>{item.idpedido}</td>
                  <td>{getValue(item.data)}</td>
                  <td>R$ {item.valorpedido.toFixed(2)}</td>
                  <td>{item.forma_pgto}</td>
                  <td>R$ {item.troco.toFixed(2)}</td>
                  <td>R$ {item.vlr_recebido.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>Não há registros para este pedido.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default PagamentosModal
